import dynamic from 'next/dynamic';

const Default = dynamic(import('./components/OverView/Default'));
const OneRTwin = dynamic(import('@/pages/product/components/ProductOverview/components/OverView/OneR/EditionTwin'));
const OneRLeica = dynamic(import('@/pages/product/components/ProductOverview/components/OverView/OneR/EditionLeica'));
const OneX2 = dynamic(import('@/pages/product/components/ProductOverview/components/OverView/OneX2'));
const OneX2Mobile = dynamic(
  import('@/pages/product/components/ProductOverview/components/OverView/OneX2/index.mobile')
);
const Go2 = dynamic(import('@/pages/product/components/ProductOverview/components/OverView/Go2'));
const Go2Mobile = dynamic(import('@/pages/product/components/ProductOverview/components/OverView/Go2/index.mobile'));
const ONE_RS = dynamic(import('@/pages/product/components/ProductOverview/components/OverView/ONE_RS'));
const ONE_RS_1_INCH = dynamic(import('@/pages/product/components/ProductOverview/components/OverView/ONE_RS_1_inch'));
const Sphere = dynamic(import('./components/OverView/Sphere'));
const Link = dynamic(import('./components/OverView/Link'));
const X3 = dynamic(import('./components/OverView/X3/entry'));
const X3DiveKit = dynamic(import('./components/OverView/X3/DiveKit/entry'));
const Go3 = dynamic(import('./components/OverView/Go3/entry'));
const FMG = dynamic(import('./components/OverView/FMG/entry'));
const X3SuctionCup = dynamic(import('./components/OverView/X3SuctionCup'));
const ACE = dynamic(import('./components/OverView/ACE'));
const ACEPro = dynamic(import('./components/OverView/ACE/AcePro'));
const GPS = dynamic(import('./components/OverView/GPSRemote'));
const SkiPoleMount = dynamic(import('./components/OverView/SkiPoleMount'));
const X4 = dynamic(import('./components/OverView/X4/entry'));
const X4Mtc = dynamic(import('./components/OverView/X4/MTC/entry'));
const X4Mtb = dynamic(import('./components/OverView/X4/MTB/entry'));
const X4Bmw = dynamic(import('./components/OverView/X4/BMW/entry'));
const X4Ski = dynamic(import('./components/OverView/X4/SKI/entry'));
const Go3s = dynamic(import('./components/OverView/Go3s/entry'));
const VB = dynamic(import('./components/OverView/VB/entry'));
const Go3sMachine = dynamic(import('./components/OverView/Go3sMachine/entry'));
const FMGpro = dynamic(import('./components/OverView/FMG_pro/entry'));
const Link2 = dynamic(import('./components/OverView/Link2/entry'));
const AcePro2 = dynamic(import('./components/OverView/AcePro2/entry'));
const Test = dynamic(import('./components/OverView/Test'));
const AcePro2XplorerVer = dynamic(import('./components/OverView/AcePro2/XplorerVer/entry'));
const FMG2pro = dynamic(import('./components/OverView/FMG2pro/entry'));
const X4Diving = dynamic(import('./components/OverView/X4/Diving/entry'));
const X5 = dynamic(import('./components/OverView/X5/entry'));

// 注意事项修改为使用说明
export const importantNotesPids = [487, 498, 440, 457, 459, 463, 464, 507, 514, 517, 528, 532, 551, 552, 553, 554, 564];
// 注意事项修改为售后说明
export const afterSalesReplacePids = [486, 491];

// moduleName 为expose曝光埋点名
const getMenu = ({ isMobile, LANG, productDetail }) => {
  const { is_camera, id: pid } = productDetail;
  // x4机型对比单独文案
  const isX4 = [26].includes(pid);

  /** 配置需要展示PDF在导航栏上的id */
  const pdfLink = {
    22: LANG['productNew.module_flow_subTitle_pdf_url'],
    28: LANG['productNew.module_flowpro_subTitle_pdf_url'],
    32: LANG['productNew.module_fmg2pro_subTitle_pdf_url'],
  };

  const menu = [
    {
      desc: '描述',
      anchor: 'a_overview_desc',
      title: LANG['productNew.description'],
      titleVisible: false,
      selected: false,
      visible: false,
      trackerAction: 'view_description',
      moduleName: 'description',
    },
    {
      desc: '产品详情',
      anchor: 'a_overview',
      title: LANG['productNew.moduleProductionIntroduction'],
      titleVisible: false,
      selected: false,
      Component: null,
      visible: true,
      order_index: 0,
      trackerAction: 'view_overview',
      moduleName: 'overview',
    },
    {
      desc: '技术参数', // 只定位新版详情图
      anchor: 'a_overview_specs',
      title: LANG['productNew.moduleSpecsTitle'],
      titleVisible: true,
      selected: false,
      visible: false,
      trackerAction: 'view_spec',
      moduleName: 'spec',
    },
    {
      // flow的pdf链接
      desc: 'PDF链接',
      anchor: 'a_pdf',
      title: LANG['productNew.module_flow_subTitle_pdf'],
      titleVisible: false,
      selected: false,
      visible: false,
      Component: null,
      enabledP: [22, 28, 32],
      trackerAction: 'view_flow_pdf',
      moduleName: 'flow_pdf',
      isUrl: true,
      urlLink: pdfLink[pid] || '',
    },
    {
      desc: '注意事项',
      anchor: 'a_importantNote',
      title: importantNotesPids.includes(pid)
        ? LANG['productNew.module_title']
        : afterSalesReplacePids.includes(pid)
        ? LANG['productNew.module_title_afterSales']
        : LANG['productNew.moduleNoteMenuTitle'],
      sectionTitle: LANG['productNew.moduleNoteSectionTitle'],
      titleVisible: true,
      selected: false,
      Component: null,
      visible: false,
      canExpend: true,
      trackerAction: 'view_notes',
      moduleName: 'notes',
    },
    {
      desc: '包装清单',
      anchor: 'a_whatInTheBox',
      title: LANG['productNew.moduleWhatsInTheBox'],
      sectionTitle: LANG['productNew.moduleWhatsInTheBox'],
      titleVisible: true,
      selected: false,
      Component: null,
      visible: false,
      canExpend: true,
      trackerAction: 'view_in_the_box',
      moduleName: 'in_the_box',
    },
    {
      desc: '宣传视频',
      anchor: 'a_videos',
      title: LANG['productNew.moduleVideosMenuTitle'],
      sectionTitle: LANG['productNew.moduleVideosSectionTitle'],
      titleVisible: true,
      selected: false,
      Component: null,
      visible: false,
      trackerAction: 'view_videos',
      moduleName: 'videos',
    },
    {
      desc: '版本对比',
      anchor: 'a_compare',
      title: isX4 ? LANG['productNew.x4_moduleCompare'] : LANG['productNew.moduleCompare'],
      sectionTitle: LANG['productNew.moduleCompare'],
      titleVisible: true,
      selected: false,
      Component: null,
      visible: true,
      trackerAction: 'view_compare',
      moduleName: 'compare',
    },
    {
      desc: '配件适配性',
      anchor: 'a_compatiblity',
      title: isMobile
        ? LANG['product.overview.accessory_compatiblity.sectionTitle']
        : LANG['product.overview.accessory_compatiblity.menu_title'],
      sectionTitle: LANG['product.overview.accessory_compatiblity.sectionTitle'],
      titleVisible: !isMobile,
      selected: false,
      Component: null,
      visible: true,
      trackerAction: 'view_compatiblity',
      moduleName: 'compatiblity',
    },
    {
      desc: 'FAQ',
      anchor: 'a_faqs',
      title: LANG['productNew.moduleFaqMenuTitle'],
      sectionTitle: LANG['productNew.moduleFaqSectionTitle'],
      titleVisible: true,
      selected: false,
      Component: null,
      visible: false,
      trackerAction: 'view_faqs',
      moduleName: 'faqs',
    },
    {
      desc: '评论模块',
      anchor: 'a_comments',
      title: LANG['comments.productPage.module_title'],
      sectionTitle: LANG['comments.productPage.module_title'],
      titleVisible: true,
      selected: false,
      Component: null,
      visible: false,
      trackerAction: 'view_comments',
      moduleName: 'comments',
    },
    {
      desc: '推荐配件',
      anchor: 'a_recommendAccessory',
      title: LANG['productNew.moduleAccessoryMenuTitle'],
      sectionTitle: LANG['productNew.moduleAccessorySectionTitle'],
      titleVisible: true,
      selected: false,
      Component: null,
      visible: false,
      trackerAction: 'view_accessories',
      moduleName: 'accessories',
    },
  ];
  // 相机和配件类型的菜单顺序不同
  if (!is_camera) {
    const intheboxIndex = menu.findIndex((d) => d.desc === '包装清单');
    const overviewIndex = menu.findIndex((d) => d.desc === '产品详情');
    const inthebox = menu.splice(intheboxIndex, 1);
    menu.splice(overviewIndex + 1, 0, ...inthebox);
  }

  return menu;
};

/**
 * 判断是否需要展示此菜单：
 * 1. disableCountry
 * 2. 默认：commoditiesList里的套餐ID匹配传入的单个菜单支持的套餐ID，
 *
 * @param {Array} menu 配置的单个菜单
 * @returns 可以展示的菜单数组
 *
 */
function addMenu(menus, commoditiesList, countryCode) {
  let menuList = [];
  menus.forEach((menu) => {
    // 判断国家
    if (menu.disableCountry?.includes(countryCode)) return;
    const hasCommoditieId = menu.commodities.some((item) => commoditiesList.some((c) => c.id === item));
    if (hasCommoditieId) {
      menuList.push(menu);
    }
  });

  return menuList;
}

export const getExtraMenusConfig = ({
  isMobile,
  LANG,
  pid,
  cid,
  countryCode,
  commoditiesList = [],
  isX4DivingOriginal,
}) => {
  switch (pid) {
    case 225:
      return [
        {
          title: LANG['product.propertyPackag.x3_bundle_name'],
          type: 'PropertyPackagX3',
          component: Default,
          commodities: [3681, 3682],
          visible: true,
          trackerAction: 'view_x3_property_package',
        },
        {
          title: LANG['product.propertyPackag.x2_bundle_name'],
          type: 'default',
          component: Default,
          commodities: [2901, 2902],
          visible: true,
          trackerAction: 'view_x2_property_package',
        },
      ];
    case 233:
      return [
        {
          title: LANG['product.dive_case.label.change_detail_page'],
          type: 'OneRS4k',
          commodities: [1736],
          visible: true,
          component: Default,
          trackerAction: 'view_onerDiveCase_oners4k_edition',
        },
        {
          title: LANG['product.dive_case.label.change_detail_page2'],
          type: 'default',
          visible: true,
          component: Default,
          trackerAction: 'view_onerDiveCase_1inch_edition',
        },
        {
          title: LANG['product.dive_case.label.change_detail_page3'],
          type: 'OneR360Mood',
          commodities: [995, 1047],
          visible: true,
          component: Default,
          trackerAction: 'view_onerDiveCase_360_edition',
        },
      ];
    case 132:
      if (cid !== 351) return null;
      return [
        {
          title: '',
          type: 'default',
          visible: false,
          component: Default,
          trackerAction: '',
        },
      ];
    case 21:
      return [
        {
          title: 'Insta360 ONE X',
          type: 'default',
          component: Default,
          visible: true,
          trackerAction: 'view_virtualTourKit_onex_edition',
        },
      ];
    case 12:
      return [
        {
          title: LANG['product.oner.label.overviewTwin'],
          specsTitle: [
            {
              ic: 'https://static.insta360.com/assets/storage/20200219/21f1cc3a0aeb98aa8e323b924929c889/twin_spc_img_4kedition_m.png',
              text: LANG['product.overview.oner_twin.common.4k_edition'],
            },
            {
              ic: 'https://static.insta360.com/assets/storage/20200219/6a12f30404cd4e8baad6470e577e9b5b/twin_spc_img_360edition_m.png',
              text: LANG['product.overview.oner_twin.common.360_edition'],
            },
          ],
          type: 'default',
          component: OneRTwin,
          visible: true,
          trackerAction: 'view_oner_twin_edition',
        },
        {
          title: LANG['product.oner.label.overviewLeica'],
          type: 'onerLeica',
          component: OneRLeica,
          commodities: [974, 1122, 1123, 1104],
          visible: true,
          trackerAction: 'view_oner_leica_edition',
        },
      ];
    case 13:
      return [
        {
          title: '通常版',
          type: 'default',
          component: isMobile ? OneX2Mobile : OneX2,
          visible: true,
          trackerAction: 'view_onex2_standard_edition',
        },
        {
          title: 'NARUTO 特別版',
          type: 'onex2Naruto',
          component: isMobile ? OneX2Mobile : OneX2,
          specialEnableCountry: ['JP'],
          commodities: [1168],
          visible: true,
          trackerAction: 'view_onex2_naruto_edition',
        },
        {
          title: 'SASUKE 特別版',
          type: 'onex2Sasuke',
          component: isMobile ? OneX2Mobile : OneX2,
          specialEnableCountry: ['JP'],
          commodities: [1174],
          visible: true,
          trackerAction: 'view_onex2_sasuke_edition',
        },
      ];
    case 14:
      return [
        {
          title: 'Insta360 GO 2',
          type: 'default',
          component: isMobile ? Go2Mobile : Go2,
          visible: true,
          trackerAction: 'view_go2_default_edition',
        },
      ];
    case 15:
      return [
        {
          title: 'Insta360 ONE RS',
          type: 'default',
          component: ONE_RS,
          visible: true,
          trackerAction: 'view_oners_default_edition',
        },
      ];
    case 16:
      return [
        {
          title: 'Insta360 Sphere',
          type: 'default',
          component: Sphere,
          visible: true,
          trackerAction: 'view_sphere_default_edition',
        },
      ];
    case 17:
      return [
        {
          title: 'Insta360 ONE RS-1-inch',
          type: 'default',
          component: ONE_RS_1_INCH,
          visible: true,
          trackerAction: 'view_one_rs_1_inch',
        },
      ];
    case 18:
      return [
        {
          title: 'Insta360 Link',
          type: 'default',
          component: Link,
          visible: true,
          trackerAction: 'view_link_default_edition',
        },
      ];
    case 19:
      return [
        {
          title: LANG['product.x3.dive_kit.navigation.x3'],
          type: 'default',
          component: X3,
          visible: true,
          trackerAction: 'view_onex3_standard_edition',
        },
        {
          title: LANG['product.x3.dive_kit.navigation.x3_dive_kit'],
          type: 'x3_dive_kit',
          component: X3DiveKit,
          commodities: [2492, 2493, 2494],
          visible: true,
          trackerAction: 'view_onex3_dive_kit_edition',
        },
      ];
    case 22:
      return [
        {
          title: 'Insta360 Flow',
          type: 'default',
          component: FMG,
          visible: true,
          trackerAction: 'view_FMG_standard_edition',
        },
      ];
    case 23:
      return [
        {
          title: LANG['product.ConstructionKit.overview.menuTitleX4'],
          type: 'default',
          component: Default,
          visible: true,
          trackerAction: 'view_X4_Construction_Kit',
        },
        {
          title: LANG['product.ConstructionKit.overview.menuTitleX3'],
          type: 'ConstructionKitX3',
          component: Default,
          commodities: [2234],
          visible: true,
          trackerAction: 'view_X3_Construction_Kit',
        },
      ];
    case 24:
      return [
        {
          title: LANG['product.ConstructionKit.overview.menuTitleX3'],
          type: 'default',
          component: Go3,
          visible: true,
          trackerAction: 'view_Go3_defalut_edition',
        },
      ];
    case 25:
      return [
        {
          title: LANG['product.Ace.acePro_moduleTitle'],
          type: 'default',
          component: ACEPro,
          visible: true,
          trackerAction: 'view_acePro_default_edition',
        },
        {
          title: LANG['product.Ace.ace_moduleTitle'],
          type: 'Ace',
          component: ACE,
          commodities: [2695, 2696, 2697, 2698, 2699, 2700, 2701, 2712],
          visible: true,
          trackerAction: 'view_ace_default_edition',
        },
      ];
    case 26:
      // eslint-disable-next-line no-case-declarations
      const x4DefaultMenu = {
        title: LANG['product.x4.x4'],
        type: 'default',
        component: X4,
        visible: true,
        trackerAction: 'view_x4_standard_edition',
      };
      // eslint-disable-next-line no-case-declarations
      const x4MTCMenu = {
        title: LANG['product.x4.mtc.moduleTitle'],
        type: 'x4_mtc',
        component: X4Mtc,
        commodities: [2997, 3008, 3375, 3376, 3377, 3378],
        visible: true,
        trackerAction: 'view_x4_mtc_edition',
      };
      // eslint-disable-next-line no-case-declarations
      const x4MTBMenu = {
        title: LANG['product.x4.mtc.mtb_moduleTitle'],
        type: 'x4_mtb',
        component: X4Mtb,
        commodities: [3395, 3396, 3397, 3398],
        visible: true,
        trackerAction: 'view_x4_mtb_edition',
      };
      // eslint-disable-next-line no-case-declarations
      const x4BmwMenu = {
        title: LANG['product.x4.bmw.details_page_title'],
        type: 'x4_bmw',
        component: X4Bmw,
        commodities: [3647, 3648],
        visible: true,
        trackerAction: 'view_x4_bmw_edition',
      };
      // eslint-disable-next-line no-case-declarations
      const x4SKIMenu = {
        title: LANG['product.x4.ski.moduleTitle'],
        type: 'x4_ski',
        component: X4Ski,
        commodities: [2999, 3000, 3010, 3011],
        visible: true,
        trackerAction: 'view_x4_ski_edition',
      };

      // 商品启用套餐里面存在BMW套餐展示MENU
      // eslint-disable-next-line no-case-declarations
      const x4PMMenu = {
        title: LANG['product.x4.PM.bundle_name'],
        type: 'x4_pm',
        component: X4,
        commodities: [3691, 3692],
        visible: true,
        trackerAction: 'view_x4_pm_edition',
      };

      // eslint-disable-next-line no-case-declarations
      const x4DivingMenu = {
        title: LANG['product.x4.diving.bundle_name'],
        type: 'x4_diving',
        component: X4Diving,
        commodities: [3001, 3012],
        visible: true,
        trackerAction: 'view_x4_diving_edition',
      };

      // eslint-disable-next-line no-case-declarations
      const res = [
        x4DefaultMenu,
        ...addMenu([x4PMMenu, x4BmwMenu], commoditiesList, countryCode),
        x4MTCMenu,
        x4MTBMenu,
        x4SKIMenu,
      ];
      // X4实验组 & 实验关闭（SDK加载失败）才需要进入实验
      !isX4DivingOriginal && res.push(x4DivingMenu);
      return res;
    case 27:
      return [
        {
          title: LANG['product.go3s.module_title'],
          type: 'default',
          component: Go3s,
          visible: true,
          trackerAction: 'view_Go3s_default_edition',
        },
      ];
    case 28:
      return [
        {
          title: 'Insta360 Flow Pro',
          type: 'default',
          component: FMGpro,
          visible: true,
          trackerAction: 'view_FMGpro_standard_edition',
        },
      ];
    case 29:
      return [
        {
          title: LANG['product.link2.module_title'],
          type: 'default',
          component: Link2,
          visible: true,
          trackerAction: 'view_link2_default_edition',
        },
      ];
    case 30:
      return [
        {
          title: LANG['product.IAC3.moduleTitle'],
          type: 'default',
          component: AcePro2,
          visible: true,
          trackerAction: 'view_AcePro2_default_edition',
        },
        {
          title: LANG['product.IAC3.moduleTitle_Xplorer'],
          type: 'XplorerVer',
          component: AcePro2XplorerVer,
          visible: true,
          commodities: [3882, 3883],
          trackerAction: 'view_AcePro2_Xplorer_edition',
        },
      ];

    case 31:
      return [
        {
          title: LANG['product.VB.module_title'],
          type: 'default',
          component: VB,
          visible: true,
          trackerAction: 'view_connect_default_edition',
        },
      ];
    case 32:
      return [
        {
          title: LANG['product.fmg2pro.module_title'],
          type: 'default',
          component: FMG2pro,
          visible: true,
          trackerAction: 'view_Fmg2pro_defalut_edition',
        },
      ];
    case 33:
      return [
        {
          title: LANG['product.x5.module_title'],
          type: 'default',
          component: X5,
          visible: true,
          trackerAction: 'view_X5_defalut_edition',
        },
      ];
    case 478:
      return [
        {
          title: 'X3SuctionCup',
          type: 'default',
          component: X3SuctionCup,
          visible: true,
          trackerAction: 'view_X3SuctionCup_defalut_edition',
        },
      ];
    case 512:
      return [
        {
          title: 'SkiPoleMount',
          type: 'default',
          component: SkiPoleMount,
          visible: true,
          trackerAction: 'view_SkiPoleMount_defalut_edition',
        },
      ];
    case 503:
      return [
        {
          title: 'GPS Preview Remote',
          type: 'default',
          component: GPS,
          visible: true,
          trackerAction: 'view_gpspreviewremote_defalut_edition',
        },
      ];
    case 552:
      return [
        {
          title: 'go-3s-standalone-camera',
          type: 'default',
          component: Go3sMachine,
          visible: true,
          trackerAction: 'view_Go3sMachine_default_edition',
        },
      ];
    case 99:
      return [
        {
          title: 'TEST',
          type: 'default',
          component: Test,
          visible: true,
          trackerAction: 'test',
        },
      ];
    default:
      break;
  }
};

/** 自定义参数样式的相机pid */
const customizeProduct = [12, 13, 14, 15, 16, 17, 18, 19, 22, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33];

// 拥有描述板块的相机pid
const descProduct = [];

// 自定义机型对比的相机pid
const compareProduct = [26, 19, 27, 28, 29, 30, 32, 33];

// 不展示包装清单的套餐id
// @卢然 https://arashivision.feishu.cn/sheets/FYYrsyrXDhxC78tgMPLc7S1XnTe?sheet=26f725
const notShowPackage = [1511, 3667, 212, 1542, 1711];

// 不展示技术参数的套餐id
// @卢然 https://arashivision.feishu.cn/sheets/FYYrsyrXDhxC78tgMPLc7S1XnTe?sheet=26f725
const notShowSpec = [1511, 3667, 212, 1542, 1711];

// 不展示注意事项的套餐id
// @卢然 https://arashivision.feishu.cn/sheets/FYYrsyrXDhxC78tgMPLc7S1XnTe?sheet=26f725
const notShowNote = [1511, 3667, 212, 1542, 1711];

/** 声明套餐选择详情类别配置 type = default || modular */
const getOverviewType = ({ cid, productModularOverview, pageCommonConfig }) => {
  if (!productModularOverview.fetchDone) return {};

  // 是否存在模块化详情配置
  const hasModularOverview = !!productModularOverview?.productOverviews?.length;
  // 主动声明为模块化，取模块化
  // const isDeclareModular = pageCommonConfig.ModularOverviewCid?.includes(cid);
  // 主动声明为默认，取默认详情
  const isDeclareDefault = pageCommonConfig.DefaultOverviewCid?.includes(cid);
  // 主动声明不取详情
  const isDeclareNone = pageCommonConfig.NoneOverviewCid?.includes(cid);

  const data = {
    isModular: hasModularOverview && !isDeclareDefault && !isDeclareNone,
    isDefault: (!hasModularOverview || isDeclareDefault) && !isDeclareNone,
  };

  return data;
};

export default {
  getMenu,
  getExtraMenusConfig,
  getOverviewType,
  customizeProduct,
  descProduct,
  compareProduct,
  notShowPackage,
  notShowSpec,
  notShowNote,
};
